<template lang="pug">
  div
    transition(name='fade')
      .fullscreen(v-if='galleryFS')
        .gallery-captions
          p(v-html="galleryCaption.caption")
          p
            | {{ galleryCaption.credit }}
        swiper.gallery(:options="swiperOption" ref="fullscreen-gallery")
          swiper-slide(v-if='!loading' v-for="image in gallery" :key="image.title")
            visual(:image="image.url")
        .swiper-button-prev(slot="button-prev")
        .swiper-button-next(slot="button-next")
        .index
          p
            | {{ galleryIndex }} of {{ numGalleryItems }}
        .less(@click="fullscreen")
            visual(image="/static/icons/x_out.svg")
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name='fade')
      .content.exhibition(v-if='!loading && !galleryFS')
        .grid
          .col-4_xs-12.titles
            router-link(:to="{ name: 'exhibitions'}")
              h2
                | exhibitions
            h4.status
              | {{ status }}
            .title-details
              h1
                | {{ title }}
              h3.teaser
                | {{ teaser }}
              h4
                | {{ date }}
              h4.curator(v-if="curator")
                | curated by: {{ curator }}
              h4.share(@click="share=!share")
                | share
              transition(name='fade')
                social(v-if="share" :meta="shareInfo")
          .col-8_xs-12
            visual(v-if="hero" :image="hero.url" background="cover" role="img" :aria-label="captions")
            p.heroCaptions(v-if="captions" v-html="captions")
            .title-details-mobile
              h1
                | {{ title }}
              h3.teaser
                | {{ teaser }}
              h4
                | {{ date }}
            .copy.wysiwyg(v-html="text" :class="{ noimage: !hero.url }")
          .col-4_xs-12.preview(v-if="gallery.length > 0")
            h2
              | exhibition preview
          .col-8_xs-12.preview(v-if="gallery.length > 0")
            .more
              .icon(@click="fullscreen")
                visual(image="/static/icons/plus_black.svg")
            swiper.gallery(:options="swiperOption" ref="gallery")
              swiper-slide(v-for="image in gallery" :key="image.title")
                visual(:image="image.url" :alt="image.meta.caption")
              .swiper-button-prev(slot="button-prev")
              .swiper-button-next(slot="button-next")
            .index
              p
                | {{ galleryIndex }} of {{ numGalleryItems }}
          .col-4_xs-12.programs(v-if="relatedPrograms.length > 0")
            h2
              | related programs
          .col-8_xs-12.programs.details(v-if="relatedPrograms.length > 0")
            .grid.no-margin
              .col-5(v-for="program in relatedPrograms" data-push-right="off-1" style="padding-left: 2.6rem")
                router-link(:to="{name: 'programs-page', params: {category: 'current', id: program.uid }}")
                  h3
                    | {{ program.title }}
                  h4
                    | {{ program.content.date}}
                  p
                    | {{ program.content.start_time }} - {{ program.content.end_time }}
          .col-4_xs-12.press(v-if="press.length > 0")
            h2
              | in the news
          .col-8_xs-12.press(v-if="press.length > 0")
            .grid.no-margin
              .col-5(v-for="article in press" data-push-right="off-1")
                a(:href="article.link" target="_blank")
                  h3
                    | {{ article.teaser }}
                  h4
                    | {{ articleDate(article.date) }}
                  p
                    | - {{ article.publication }}
          .col-4_xs-12.resources(v-if="resources.length > 0")
            h2
              | resources
          .col-8_xs-12.resources(v-if="resources.length > 0")
            .grid.no-margin
              .col-5_xs-12(v-for="resource in resources" data-push-right="off-1_xs-0")
                a(:href="resource.link" target="_blank")
                  h3
                    | {{ resource.title }}
    bottom-nav(footerColor="white" v-if='!galleryFS')
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import dateFormat from 'dateformat'

export default {
  name: 'exhibition',
  key: null,
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      galleryFS: false,
      galleryIndex: 1,
      share: false,
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: false,
        onSlideChangeEnd: swiper => {
          this.galleryIndex = swiper.realIndex + 1
        },
        onInit: (swiper) => {
          swiper.slideTo(this.galleryIndex - 1, 0, false)
        }
      }
    }
  },

  created () {
    this.key = 'exhibitions/' + this.$route.params.year + '/' + this.$route.params.id
    this.requestData(this.key, 'exhibition')
  },

  methods: {
    programDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'dddd, mmmm d, yyyy')
      } else {
        return ''
      }
    },

    articleDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d, yyyy')
      } else {
        return ''
      }
    },

    fullscreen: function () {
      this.galleryFS = !this.galleryFS
      if (this.galleryFS) {
        document.getElementById('header').style['z-index'] = -1
      } else {
        document.getElementById('header').style['z-index'] = 9999
      }
    }
  },

  computed: {
    content: function () {
      return this.loadedData[this.key].content
    },

    startDate: function () {
      return this.content.start_date
    },

    endDate: function () {
      return this.content.end_date
    },

    startYear: function () {
      return this.content.start_year
    },

    endYear: function () {
      return this.content.end_year
    },

    date: function () {
      const endDate = this.endDate + ', ' + this.endYear
      let startDate = startDate = this.startDate
      if (this.endYear !== this.startYear) {
        startDate = this.startDate + ', ' + this.startYear
      }
      return startDate + ' - ' + endDate
    },

    status: function () {
      return this.content.status
    },

    title: function () {
      return this.content.title
    },

    teaser: function () {
      return this.content.teaser
    },

    text: function () {
      return this.content.text
    },

    resources: function () {
      return this.content.resources
    },

    press: function () {
      return this.content.press
    },

    files: function () {
      return this.loadedData[this.key].files
    },

    hero: function () {
      const name = this.content.main_image
      if (name.length > 0) {
        return this.files.find(item => item.filename === name)
      } else {
        return false
      }
    },

    captions: function () {
      let captionString = ''
      if (this.hero) {
        const caption = this.hero.meta.caption
        const credit = this.hero.meta.credit

        if (caption) {
          captionString += caption + '. '
        }
        if (credit) {
          captionString += credit + '.'
        }

        return captionString
      } else {
        return false
      }
    },

    gallery: function () {
      if (this.content.gallery) {
        const names = this.content.gallery.split(',')
        let i = names.length
        let files = []
        while (i--) {
          files.push(this.files.find(item => item.filename === names[i]))
        }
        return files.reverse()
      } else {
        return []
      }
    },

    galleryCaption: function () {
      const item = this.gallery[this.galleryIndex - 1]
      const captionData = item.meta.caption
      const creditData = item.meta.credit
      let caption = ''
      let credit = ''

      if (captionData) {
        caption = captionData + '. '
      }
      if (creditData) {
        credit = creditData + '.'
      }

      return {caption, credit}
    },

    numGalleryItems: function () {
      return this.gallery.length
    },

    relatedPrograms: function () {
      return this.loadedData[this.key].programs
    },

    curator: function () {
      const curator = this.content.curator
      return curator.length > 0 ? curator : false
    },

    shareInfo: function () {
      const data = {
        url: this.loadedData[this.key].url,
        title: this.title,
        description: this.text,
        image: this.hero.url
      }
      return data
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .fullscreen
    position:fixed
    top: 0
    left: 0
    background-color: rgba(255,255,255,0.9)
    .gallery-captions
      position: fixed
      top: 50%
      width: 20%
      left: 3.81vW
      transform: translateY(-50%)
    .swiper-container
      width: 71vW
      height: calc(100vH - 4rem)
      padding-top: 2rem
      margin-right: 0
      margin-left: 25.19vW
      .vv-visual
        height: 100vH
        width: 100%
        padding: 0
        .vv-transition
          display: flex
          justify-content: center
          align-items: center
          height: 100vH
        .vv-image
          max-width: 100%
          max-height: 100%
          padding: 0
    .less
      position: fixed
      left: $margin
      top: calc(100vH - 5rem)
      width: 3rem
      cursor: pointer
    .index
      position: fixed
      color: black
      top: calc(100vH - 5.5rem)
      left: 13.88vW
      width: calc(7.62vW + 3rem)
      text-align: center
    .swiper-button-prev
      position: fixed
      left: 13.88vW
      top: calc(100vH - 4.3rem)
      background-image: url('/static/icons/left_arrow.svg')
    .swiper-button-next
      position: fixed
      left: 21.5vW
      top: calc(100vH - 4.3rem)
      background-image: url('/static/icons/right_arrow.svg')
  .exhibition
    .vv-visual
      width: 100%
      height: 0
      padding-bottom: 78.5%
      .vv-image
        width: 100%
        height: 0
        padding-bottom: 78.5%
        background-repeat: no-repeat
        background-size: cover
    .heroCaptions
      font-size: 1.2rem
      margin-top: 1rem
      color: #939598
    .copy
      width: 65%
      margin-top: 6rem
      &.noimage
        margin-top: 14rem
      @include respond-to(xs)
        width: 100%
        margin-top: 2rem
      a
        text-decoration: underline
      p
        margin-bottom: 1.7rem
      ul
        margin-bottom: 1.7rem
        margin-left: 2rem
        padding-left: 3.7rem
        li
          list-style-type: circle
    h2
      letter-spacing: $kerningTight
      @include respond-to(xs)
        letter-spacing: -0.06rem
    .titles
      margin-top: 14rem
      @include respond-to(xs)
        margin-top: 0
      .title-details
        h1
          font-style: italic
        @include respond-to(xs)
          display: none
      h1, .status, .teaser
        color: #FD0000
      h1
        padding-top: 1rem
        line-height: 95%
        letter-spacing: -0.2rem
      .teaser
        font-style: italic
      h4
        font-size: 2rem
        margin: 0
        line-height: 150%
        letter-spacing: $kerningh4
        &.share
          margin-top: 2rem
          cursor: pointer
          color: #939598
      .teaser
        font-size: 3rem
    .title-details-mobile
      display: none
      margin-top: 1rem
      @include respond-to(xs)
        display: block
      h1
        font-style: italic
      h1, .teaser
        color: #FD0000
    .preview
      margin-top: 16rem
      @include respond-to(xs)
        margin-top: 0rem
      .index
        width: 65vW
        margin-left: -1.25vW
        text-align: center
        margin-top: 1rem
        @include respond-to(xs)
          width: 100%
          margin-left: 0
    .more
      position: relative
      width: 100%
      z-index: 9
      @include respond-to(xs)
        display: none
      .icon
        position: absolute
        width: 3rem
        top: 0rem
        right: -4rem
        cursor: pointer
        .vv-visual
          width: 100%
          height: 0
          padding-bottom: 78.5%
          .vv-image
            width: 100%
            height: auto
            padding-bottom: 0
    .gallery
      width: 65vW
      height: 34.5vW
      margin-left: -1.25vW
      @include respond-to(xs)
        width: 100%
        height: 52vW
      .swiper-slide
        display: flex
        justify-content: center
      .vv-visual
        height: 34.5vW
        width: 88%
        padding: 0
        @include respond-to(xs)
          width: 100%
        .vv-transition
          display: flex
          justify-content: center
          align-items: center
          height: 34.5vW
        .vv-image
          width: auto
          max-width: 100%
          height: 34.5vW
          padding: 0
          @include respond-to(xs)
            width: 100%
            height: unset
      .swiper-button-prev
        left: 0px
        background-image: url('/static/icons/left_arrow.svg')
      .swiper-button-next
        right: 0
        background-image: url('/static/icons/right_arrow.svg')
      .swiper-button-next, .swiper-button-prev
        @include respond-to(xs)
          display: none
    .press, .resources, .programs
      margin-top: 8rem
      @include respond-to(xs)
        margin-top: 0
      h3, h4, a
        padding: 0
        margin: 0
      h3, h4
        margin-left: $pageMargin
        @include respond-to(xs)
          margin-left: 0
      h3
        font-size: 3rem
        padding-top: 0.4rem
        letter-spacing: -0.19
        @include respond-to(xs)
          font-size: 1.5rem
          letter-spacing: -0.06rem
      h4
        font-size: 2rem
        @include respond-to(xs)
          font-size: 1rem
          letter-spacing: -0.06rem
      p
        font-size: 1.8rem
        padding-left: 0
        letter-spacing: 0
        margin: 0
        margin-left: $pageMargin
        @include respond-to(xs)
          margin-left: 0
          font-size: 1rem
    .press
      a
        &:hover p
          border-bottom: solid 2px #000
      p
        display: inline
        border-bottom: solid 2px #FFF
    .resources
      *
        @include respond-to(xs)
          padding-bottom: 0.25rem !important
    .programs
      &.details
        padding-left: 1.1rem
      a
        margin-left: 0
        &:hover h3
          border-bottom: solid 2px #000
      h3
        display: inline
        margin: 0
        border-bottom: solid 2px #FFF
      h4, p
        margin-left: 0
</style>



// WEBPACK FOOTER //
// Exhibition.vue?7a5dd37d